<template>
  <button class="kakuninnshitai" type="submit">入力内容を確認</button>
</template>

<style src="../common/common-button.css"></style>
